import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Datasheet from "react-datasheet";
import { Button } from "antd";
import { 
    OrderedMap,
    Map, 
    // List
} from "immutable";
import shortID from "uuid/v4";
import { UI_LIST_ITEM_TYPES } from "constants";

// const valueRenderer = (_, key, type) => {
//     console.log(_, type, key, _[key]);
//     return _ && (type && _[key] ? _[key].toFixed(2) : _[key]);
// };

const SPOC_DETAIL_FIELDS = () => new OrderedMap({
    // labels: {
    //     label: "Details",
    //     type: UI_LIST_ITEM_TYPES.LIST_ITEM_HEADER
    // },
    name: {
        label: "Name",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
    },
    phone: {
        label: "Phone No",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    email: {
        label: "Email",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    }
});


class SpocDetailForm extends React.Component{
    state = {
        data: [],
        ids: new Map({}),
        removed_ids: [],
    }

    getState() {
        const state = {};
        if(this.props.values && this.props.values.size) {
            state.ids = this.props.values.map((v) => v.id);
        } else {
            const newID = shortID();
            state.ids = new Map({newID});
        }

        return state;
    }

    edit = true;
    fields = null;
    
    generateCols() {
        this.fields = SPOC_DETAIL_FIELDS();
        let grid_header = this.fields.map((_, k) => {
            if (_.type === UI_LIST_ITEM_TYPES.SECTION) {
                return [
                    {
                        value: _.label,
                        readOnly: true,
                        itemKey: k,
                        type: _.type,
                        colSpan: this.fields && this.fields.size
                    }
                ];
            }
            return ({
                value: _.label,
                readOnly: true,
                colSpan: 1,
                type: _.type,
                itemKey: k
            });
        }).toList().toArray();

        let grid_content = this.state.ids.map(_ => (
            [
                // {
                //     value: "",
                //     readOnly: true,
                //     type: "LIST_ITEM_HEADER"
                // },
                ...this.fields.filter(_ => !["SECTION", "LIST_ITEM_HEADER"].includes(_.type)).map((__, k) => {
                    return ({
                        value: this.props.values && this.props.values.get(_) ? 
                            this.props.values.get(_)[k] 
                            : __.value,
                        itemKey: `${_}|${k}`,
                        type: __.type,
                        dataType: __.dataType,
                        readOnly: false,
                        dataEditor: __.component
                    });
                }).toList().toArray()
            ]
        )).toList().toArray();

        let grid_data = [grid_header, ...grid_content];
        return grid_data;
    }

    componentDidMount() {
        this.edit = true;
        // this.fields
        this.setState({
            ...this.getState(),
            
        }, () => this.setState({
            data: this.generateCols()
        }));
    }

    cellRenderer = (cell) => {
        if(cell && cell.dataType === "SELECT") {
            return cell.value ? cell.options.findKey(_ => _ === cell.value) : "";
        }
        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && (cell.value.name || cell.value.label )) {
            return cell.value ? (cell.value.name ? cell.value.name : cell.value.label) : "";
        }

        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && typeof cell.value !== "string" && cell.value.length > 0) {
            return cell.value ? (cell.value.map(_ => _.name ? _.name : _.label).join("; ")) : "";
        }

        if(cell.value && cell.value._isAMomentObject) {
            return cell.value.format("DD-MM-YYYY");
        }

        if(cell.value && isNaN(cell.value)) {
            return cell.value;
        }
        if(!cell.value) {
            return "--";
        }
        return cell.value;
    }

    toggleFormGrid = (action = "ADD", id) => {
        const { ids } = this.state;
        let removed_ids = this.state.removed_ids;
        const newID = shortID();
        switch (action) {
        case "ADD":
            this.setState({
                ids: ids.set(newID, newID)
            }, () => {
                this.setState({
                    data: this.generateCols()
                });
            });
            break;
        case "REMOVE": {
            removed_ids.push(id);
            this.setState({
                removed_ids: removed_ids
            });
            break;
        }
        default:
        }
    };

    updateAssociates = () => {
        const obj = {};
        let data = this.state.data;

        data.map((_, key) => {
            _.filter(__ => __.type === UI_LIST_ITEM_TYPES.LIST_ITEM)
                .map((v) => {
                    obj[key] = {
                        ...obj[key],
                        [v.itemKey.split("|")[1]] : typeof v.value === "object" ? 
                            (v.value.length > 0  ? v.value.map(__ => (__.value || __.id)) : v.value["value"] ? v.value["value"] : v.value["id"]) :                   
                            v.value === "" ? 0 : 
                                typeof v.value === "string" ? 
                                    v.value : Number(v.value)
                    };
                    
                });
        });

        let newObj = new Map(obj).map(_ => ({
            ..._,
            company: this.props.companyId
        })).toList().toJS();
        this.props.updateAssociates(newObj);
    }

    render() {
        console.log(this.props.values);
        return (
            <React.Fragment>
                <div className={cx("mb-10 mr-10 w-100")}>
                    <Button
                        type="primary"
                        icon={"plus"}
                        onClick={this.toggleFormGrid.bind(null, "ADD")}>
                        Add New
                    </Button>
                </div>
                <div className={"m-5 spreadsheet-table"}>
                    <Datasheet
                        data={this.state.data}
                        valueRenderer={cell =>
                            this.cellRenderer(cell)
                        }
                        onCellsChanged={changes => {
                            this.edit = true;
                            this.saveActive = true;
                            const grid = this.state.data.map(row => [...row]);
                            changes.forEach(({ row, col, value }) => {
                                let error = false;
                                // if (
                                //     value &&
                                //     value.length > 0 &&
                                //     isNaN(Number(value))
                                // ) {
                                //     error = true;
                                //     this.saveActive = false;
                                // }
                                grid[row][col] = {
                                    ...grid[row][col],
                                    value,
                                    className: error ? "error-cell" : null
                                };
                            });
                            this.setState({ data: grid });
                        }}
                    />  
                </div>
                <div className="d-flex justify-content-flex-end mr-5" style={{paddingTop: "5px"}}>
                    <Button key="save" type="primary" icon={"plus"} onClick={this.updateAssociates}>{"Update"}</Button>
                </div>
            </React.Fragment>
        );
    }
}

SpocDetailForm.propTypes = {
    values: PropTypes.object,
    companyId: PropTypes.number,
    updateAssociates: PropTypes.func

};

export default SpocDetailForm;